<template>
  <div class="left cadfm-flexitem-fixed scrollbars">
    <div class="Tabs">
      <action-panel>
        <action-bar>
          <b-navbar-nav>
            <action-button @click="toggleLeftPanel" icon="hide" bold :text="lang.button_Hide"
              :tooltip="lang.button_Hide" :disabled="false" />
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <!-- <action-button @click="categories" icon="edit-categories" bold :text="lang.button_Categories" 
              :tooltip="lang.button_Categories" :disabled="categoriesButtonStatus" />-->

          </b-navbar-nav>
        </action-bar>
        <action-content>
          <b-tabs card>

            <b-tab :title="lang.Content.tab_Search" :title-link-class="textColors" :title-item-class="textColors"
              active>


            </b-tab>

          </b-tabs>



        </action-content>
      </action-panel>
    </div>
  </div>
</template>



<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import ActionButton from '@/components/shared/ActionButton'
import TitleComponent from "@/components/shared/TitleComponent"
import TreeComponent from "@/components/shared/TreeComponent"

export default {
  name: 'Left',
  components: {
    ActionBar,
    ActionContent,
    ActionPanel,
    ActionButton,
    TitleComponent,
    TreeComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      title: "Categories of parts",

      categoriesButtonStatus: false,
      editCategories:false,

    }
  },
  computed: {
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },

  methods: {

    categories(){

      let to = "/PartManager/Categories";
      
      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },

    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.left {

  border-right: 1px solid #666;

}

/*
  .col{
    padding-right: 0px;
    padding-left: 0px;
  }
  .titlecomponent{
    margin-left: 10px;
  }
  .treecomponent{
    margin-left: 10px;
  }
*/
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/UL/Left/Left.vue